import { WorkItemFind, WorkItemFindResult } from '../../notification/work-item-request';

/**
 * Rpc work item find sever side handler interface.
 */
export interface RpcWorkItemFindHandler {
    handler(data: WorkItemFind): Promise<WorkItemFindResult>;
}
